(() => {
  const closeNavigation = (nav, except = null) => {
    nav.querySelectorAll('[data-ic-nav-department]').forEach(item => {
      if (item === except) return;
      item.classList.remove('is-open');
      item.querySelector('[data-ic-nav-toggle]').setAttribute('aria-expanded', 'false');
      item.querySelector('[data-ic-nav-panel]').hidden = true;
    });
    nav.querySelectorAll('details').forEach(item => {
      if (item !== except && (!except || (!item.contains(except) && !except.contains(item)))) item.open = false;
    });
  };

  const initialiseNavigation = nav => {
    if (!nav || nav.dataset.icNavigationReady) return;
    nav.dataset.icNavigationReady = 'true';
    nav.querySelectorAll('[data-ic-nav-toggle]').forEach(button => {
      button.addEventListener('click', () => {
        const item = button.closest('[data-ic-nav-department]');
        const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
        closeNavigation(nav);
        if (shouldOpen) {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          item.querySelector('[data-ic-nav-panel]').hidden = false;
        }
      });
    });
    nav.querySelectorAll('details').forEach(item => item.addEventListener('toggle', () => {
      if (item.open) closeNavigation(nav, item);
    }));
    nav.addEventListener('focusout', event => {
      if (event.relatedTarget && !nav.contains(event.relatedTarget)) closeNavigation(nav);
    });
  };

  document.querySelectorAll('.ic-retail-nav').forEach(initialiseNavigation);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.ic-retail-nav').forEach(initialiseNavigation);
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.ic-retail-nav').forEach(nav => {
      if (!nav.contains(event.target)) closeNavigation(nav);
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ic-retail-nav').forEach(nav => {
      const mobile = nav.querySelector('.ic-retail-nav__mobile[open] > summary');
      const trigger = mobile || nav.querySelector('[data-ic-nav-toggle][aria-expanded="true"], .ic-retail-nav__trade[open] > summary');
      if (trigger) {
        closeNavigation(nav);
        if (nav.contains(document.activeElement)) trigger.focus();
      }
    });
  });

  const sortAvailableFirst = grid => {
    const cards = [...grid.children].filter(card => card.matches('.product-item'));
    if (cards.length < 2) return;
    cards.sort((a, b) => {
      const aAvailable = a.dataset.icAvailable === 'true' ? 1 : 0;
      const bAvailable = b.dataset.icAvailable === 'true' ? 1 : 0;
      return bAvailable - aAvailable;
    });
    cards.forEach(card => grid.appendChild(card));
  };

  document.querySelectorAll('.ic-product-grid, [data-ic-product-grid]').forEach(sortAvailableFirst);

  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('.ic-product-grid, [data-ic-product-grid]').forEach(sortAvailableFirst);
  });

  document.querySelectorAll('[data-ic-brand-search]').forEach(input => {
    const section = input.closest('[data-section-type="ic-brands-directory"]');
    const cards = [...(section?.querySelectorAll('[data-ic-brand]') || [])];
    const empty = section?.querySelector('[data-ic-brand-empty]');
    input.addEventListener('input', () => {
      const query = input.value.trim().toLowerCase();
      let visible = 0;
      cards.forEach(card => {
        const match = !query || card.dataset.icBrand.includes(query);
        card.hidden = !match;
        if (match) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    });
  });
})();
